<template>
    <div>
        <div class="card mb-4">
            <div class="card-header">
                <h2>Nieuwe deelnemers</h2>
            </div>
            <div class="card-body">
                <p>Dit zijn de nieuwste deelnemers.</p>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Naam</th>
                                <th>Bedrijf</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(member, key) in members" :key="key">
                                <td>{{ member.id }}</td>
                                <td>{{ member.name | limit }}</td>
                                <td>{{ member.bedrijfsnaam | limit }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        members: Array
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/NieuweLeden.vue